var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"vh-full ps-re lynn-mobile",attrs:{"fluid":""}},[_c('v-img',{attrs:{"src":require('@/assets/contract_status.png'),"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }